<template>
  <component v-if="config" :is="config.icon" :class="config.class" :size="size" />
  <span v-else>-</span>
</template>

<script>
import { vorzeitigGarantiertIcon } from '@/core/common/helpers/utils';

export default {
  name: 'CustomIconVorzeitigGarantiert',
  props: {
    value: {
      type: String,
      default: null,
    },
    size: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    config() {
      return vorzeitigGarantiertIcon(this.value);
    },
  },
};
</script>
